export const DEFAULT_SLOPE = 0.0;

export const GRASS_KEY_NAT_GROS = 'NAT_GROS';
export const GRASS_KEY_GZD_GROS = 'GZD_GROS';
export const GRASS_KEY_EO_GROS = 'EO_GROS';

export const GFDI_COLORS = {
  scale: {
    '12': 'rgb(122, 193, 66, 0.7)',
    '25': 'rgb(0, 174, 239, 0.7)',
    '35': 'rgb(250, 253, 159, 0.7)',
    '50': 'rgb(255, 240, 0, 0.7)',
    '100': 'rgb(248, 152, 41, 0.7)',
    '150': 'rgb(238, 46, 36, 0.7)'
  },
  else: 'rgb(133, 12, 6, 0.7)'
};



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/grass/constants.js